<template>
  <div class="layout-topbar">
    <img
      v-if="empresa.logo"
      :src="'data:image/png;base64, ' + empresa.logo"
      width="100"
      height="60"
      alt="Logo.jpg"
    />
    <button
      class="p-link layout-menu-button layout-topbar-button"
      @click="onMenuToggle"
    >
      <i class="pi pi-bars"></i>
    </button>
    <button
      class="p-link layout-topbar-menu-button layout-topbar-button"
      v-styleclass="{
        selector: '@next',
        enterClass: 'hidden',
        enterActiveClass: 'scalein',
        leaveToClass: 'hidden',
        leaveActiveClass: 'fadeout',
        hideOnOutsideClick: true,
      }"
    >
      <i class="pi pi-ellipsis-v"></i>
    </button>
    <div class="centro-topbar">
      <span class="estilo-fecha"> {{ currentDateTime }}</span>
    </div>

    <!-- Botones de Perfil y Salir -->
    <div class="right-topbar">
      <span class="usuario-name"
        ><strong>Usuario: </strong>{{ user.name }}</span
      >

      <Button
        class="p-button-text p-button-lg p-button-info"
        @click="irAPerfil"
        v-tooltip.bottom="'Perfil'"
      >
        <i class="pi pi-fw pi-user"></i>Perfil
      </Button>

      <!-- data-testid: pruebas automáticas (e2e/) -->
      <Button
        class="p-button-text p-button-lg p-button-danger"
        data-testid="topbar-salir"
        @click="openNuevo"
        v-tooltip.bottom="'Salir'"
      >
        <i class="pi pi-fw pi-sign-in"></i>Salir
      </Button>
    </div>
  </div>

  <!-- Dialogo de Cerrar Sesión -->
  <Dialog
    v-model:visible="salirDialog"
    :style="{ width: '450px' }"
    header="Cerrar Sesión"
    :modal="true"
    class="p-fluid"
  >
    <h4><strong>Est&aacute;s seguro de Cerrar Sesión?</strong></h4>
    <!-- Etapa 3D (C): ventas de este usuario todavía sin enviar -->
    <Message v-if="conexion.ventasEnColaUsuario > 0" severity="warn" :closable="false" data-testid="salir-aviso-cola">
      Tiene <b>{{ conexion.ventasEnColaUsuario }} ventas sin enviar</b>. Quedan guardadas en este equipo, pero solo se enviarán
      cuando <b>usted</b> vuelva a iniciar sesión aquí, con conexión.
      <span v-if="conexion.modoOffline"><br /><b>Sin conexión no podrá volver a iniciar sesión</b> (ni usted ni otro cajero) hasta que vuelva internet.</span>
    </Message>
    <!-- Etapa 4 (d): cierre de caja guardado en este equipo, sin enviar -->
    <Message v-if="conexion.cierresPendientes > 0" severity="warn" :closable="false" data-testid="salir-aviso-cierre">
      Hay un cierre de caja sin enviar. Se enviará cuando usted vuelva a iniciar sesión aquí, con conexión.
    </Message>
    <template #footer>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-outlined p-button-success mr-2 mb-2 p-button-lg"
        data-testid="salir-cancelar"
        @click="ocultarDialog"
      />
      <!-- Etapa 3D (C): enviar la cola antes de salir (no cierra sesión sola: decide el cajero) -->
      <Button
        v-if="conexion.ventasEnColaUsuario > 0 && !conexion.modoOffline"
        label="Enviar ahora"
        icon="pi pi-sync"
        :loading="conexion.sincronizando"
        class="p-button-outlined mr-2 mb-2 p-button-lg"
        data-testid="salir-enviar"
        @click="enviarAntesDeSalir"
      />
      <!-- Etapa 3D (C): antes label="Cerrar Sesión" fijo; con ventas propias sin enviar (D4: se permite igual, también sin red) -->
      <Button
        :label="conexion.ventasEnColaUsuario > 0 ? 'Cerrar sesión igual' : 'Cerrar Sesión'"
        icon="pi pi-check"
        class="p-button-outlined p-button-danger mr-2 mb-2 p-button-lg"
        data-testid="salir-confirmar"
        @click="cerrarSession()"
      />
    </template>
  </Dialog>
</template>

<script>
import { useAuth, useConexion } from "@/stores";
import EmpresaService from "@/service/EmpresaService";
import { sincronizarAhora } from "@/services-offline/sincronizador";

export default {
  emits: ["menu-toggle"],
  data() {
    return {
      empresa: {},
      user: {},
      fechaActual: new Date(),
      salirDialog: false,
      conexion: useConexion(), // Etapa 3D (C): ventas sin enviar al cerrar sesión
      /* nestedMenuitems: [
        {
          label: "Perfil",
          icon: "pi pi-fw pi-user",
          items: [
            {
              label: "Ver Perfil",
              icon: "pi pi-user",
              to: "/usuario-detalle",
            },
          ],
        },
      ], */
      currentDateTime: "",
    };
  },
  auth: null,
  empresaService: null,
  beforeCreate() {
    this.empresaService = new EmpresaService();
    this.empresaService.getFirstEmpresa().then((response) => {
      this.empresa = response.data;
    });
  },
  created() {
    this.auth = useAuth();
    this.updateDateTime();
    setInterval(this.updateDateTime, 1000);
  },
  mounted() {
    this.user = { ...this.auth.user };
  },
  methods: {
    irAPerfil() {
      this.$router.push("/usuario-detalle");
    },
    updateDateTime() {
      const now = new Date();
      this.currentDateTime = now.toLocaleString(); // Actualiza la propiedad con la fecha y hora actual
    },
    openNuevo() {
      // Etapa 3D (C): el número de ventas sin enviar, al día al abrir el diálogo
      this.conexion.refrescarContadoresCola().catch(() => {});
      this.salirDialog = true;
    },
    // Etapa 3D (C): envía la cola del usuario; el aviso se actualiza solo y desaparece con 0 pendientes
    enviarAntesDeSalir() {
      sincronizarAhora({ manual: true });
    },
    ocultarDialog() {
      this.salirDialog = false;
    },
    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
    onTopbarMenuToggle(event) {
      this.$emit("topbar-menu-toggle", event);
    } /* 
				topbarImage() {
					return this.$appState.darkTheme ? 'images/logo-white.svg' : 'images/logo-dark.svg';
				}, */,
    cerrarSession() {
      return this.auth.userLogout();
    },
  },
  computed: {
    darkTheme() {
      return this.$appState.darkTheme;
    },
  },
};
</script>
<style scoped>
.centro-topbar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  margin-left: 10px;
}

.estilo-fecha {
  font-size: 1.4rem;
  font-weight: bold;
}

.right-topbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 1.2rem;
}

.usuario-name {
  display: none;
}

/* Mostrar nombre de usuario solo en pantallas grandes */
@media (min-width: 1024px) {
  .usuario-name {
    display: inline;
    margin-right: 10px;
  }
}

/* Ajuste de los botones en pantallas móviles */
@media (max-width: 768px) {
  .right-topbar {
    flex-direction: column;
    align-items: flex-end;
  }

  .right-topbar button {
    margin-bottom: 5px;
  }
}
</style>
